import VueRouter from "vue-router";
import routes from "./routes";
import * as lang from "../store/lang";
import LangStore from "../store/lang-store";

const router = new VueRouter({
	mode: 'history',
	routes
})

router.beforeEach((to, from, next) => {
	const toArray = to.path.split('/');
	const toLocale = lang.ALL_LOCALES.includes(toArray[1] ?? '') ? toArray[1] : 'lv';

	let currentLocale = LangStore.state.currentLocale;

	let navItem = document.getElementById('nav-icon1');
	if (navItem) {
		navItem.classList.toggle('open');
	}

	// Change locale if necessary
	if (lang.ALL_LOCALES.includes(toLocale) && currentLocale !== toLocale) {
		LangStore.commit('changeLocale', toLocale)
	}

	next();
})

export default router;